<template>
  <!-- 战团管理-战团配置 -->
  <div class="battle_bonus-box">
    <!-- header头部 -->
    <!-- <header>战团配置</header> -->
    <!-- body内容  -->
    <div class="body-box" v-if="formData">
      <el-form :model="formData" label-width="150px" ref="paymentForm">
        <el-form-item prop="aim_update_count" label="编辑宗旨次数(每周)：">
          <el-input v-model="formData.aim_update_count"></el-input>
        </el-form-item>
        <el-form-item prop="team_consume_amount" label="建团花费钻石：">
          <el-input v-model="formData.team_consume_amount"></el-input>
        </el-form-item>
        <el-form-item prop="name" label="建团最低等级：">
          <el-input v-model="formData.team_min_level"></el-input>
        </el-form-item>
        <el-form-item prop="exit_freeze" label="退团冷静期：">
          <el-input v-model="formData.exit_freeze"></el-input>
        </el-form-item>

        <el-divider content-position="left">战团红包</el-divider>

        <el-form-item prop="red_rate" label="红包返利比例：">
          <el-input v-model="formData.red_rate"></el-input>
        </el-form-item>
        <el-form-item prop="user_red_min_water" label="抢红包资格：">
          <el-input v-model="formData.user_red_min_water"></el-input>
        </el-form-item>
        <el-form-item prop="red_min_amount" label="发红包最低额：">
          <el-input v-model="formData.red_min_amount"></el-input>
        </el-form-item>
        <el-form-item prop="user_min_water" label="转换贡献最低值：">
          <el-input v-model="formData.user_min_water"></el-input>
        </el-form-item>

        <el-divider content-position="left">积分商城</el-divider>

        <el-form-item prop="point_ratio_battle" label="热血盲盒系数：">
          <el-input v-model="formData.point_ratio_battle"></el-input>
        </el-form-item>
        <el-form-item prop="point_ratio_lottery" label="普通开箱系数：">
          <el-input v-model="formData.point_ratio_lottery"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="submit"
            :loading="buttonLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { getCookie } from '@/utils/cookie'

export default {
  name: 'battle_bonus',
  components: {
  },
  data() {
    return {
      dialogVisible: false,//弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
      },
      formData: {
        exit_freeze: '',
        red_rate: '',
        user_red_min_water: '',
        red_min_amount: '',
        user_min_water: '',
        team_consume_amount: '',
        aim_update_count: '',
        team_min_level: '',
        point_ratio_battle:'',
        point_ratio_lottery:'',
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}member_card_user`
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('team_configs').then(res => {
        if (res) {
          this.formData = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      //提交
      if(this.formData.point_ratio_battle<=0 || this.formData.point_ratio_battle>1){
        this.$message.warning("热血盲盒系数必须为0-1之间的数")
        return
      }
      if(this.formData.point_ratio_lottery<=0 || this.formData.point_ratio_lottery>1){
        this.$message.warning("普通开箱系数必须为0-1之间的数")
        return
      }

      let params = this.formData
      patchApiData(`team_configs`, params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.getData()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.battle_bonus-box {
  header {
  }

  .body-box {
    width: 300px;
  }
}
</style>